import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({
  name: 'bpc-invoice-select-info',
  components: {},
})
export default class InvoiceSelectInfo extends Vue {
  @Prop(Object) readonly element: Record<string, any>;

  public onClick($event) {
    this.$emit('click', this.element);
  }
}
